import { GuidService } from 'ui-components/services/guid-service';
import { WORKFLOW_ACTION_TYPE } from '../../../api/automation-workflow-types';
import type { WorkflowAction as ApiWorkflowAction } from '../../../api/automation-workflow-types';
import type { WorkflowActionDraft } from '../../types.d';

type ActionTypeHandler = {
  fromApi: (definition: ApiWorkflowAction['definition']) => WorkflowActionDraft;
  toApi: (draft: WorkflowActionDraft) => ApiWorkflowAction['definition'];
};

const orderRuleActionHandler: ActionTypeHandler = {
  fromApi: (definition) => ({
    id: GuidService.newGuid(),
    actionTypeId: definition.actionTypeId,
    parameter: definition.parameter,
    intParameter: definition.intParameter,
  }),

  toApi: (draft) => ({
    actionTypeId: draft.actionTypeId,
    parameter: draft.parameter,
    intParameter: draft.intParameter,
  }),
};

// Dispatch map — add new action types here when the backend introduces them
export const actionTypeHandlers: Partial<Record<string, ActionTypeHandler>> = {
  [WORKFLOW_ACTION_TYPE.orderRuleAction]: orderRuleActionHandler,
};
